import React__default, { useState, useCallback } from 'react';
import { Avatar } from '@sravni/react-design-system/lib/Avatar';
import { Badge } from '@sravni/react-design-system/lib/Badge';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { RegionDialog } from '@sravni/react-region-dialog';
import { useStyles, useBoolean } from '@sravni/react-utils';
import { useAnalyticEvents } from '../../../hooks/useAnalyticEvents.js';
import { useUserNotification } from '../../../hooks/useUserNotification.js';
import { getUserName } from '../../../utils/user.js';
import '../../Providers/CustomPropsProvider/src/CustomPropsProvider.js';
import { useCustomProps } from '../../Providers/CustomPropsProvider/hooks/useCustomProps.js';
import { UserMenu } from '../../UserMenu/src/UserMenu.js';
import modules_6049fac5 from '../styles/DesktopUserBlock.module.less.js';

const DesktopUserBlock = (props) => {
    const { className, onMouseEnter, ...restProps } = props;
    const { user, serviceURL = '/', formatPath, regions } = useCustomProps();
    const cx = useStyles(modules_6049fac5);
    const { pushAnalyticEvent } = useAnalyticEvents();
    const [menuVisible, setMenuVisible] = useBoolean(false);
    const { data: notification } = useUserNotification();
    const hasNotification = !!notification && notification.count > 0;
    const [isVisibleRegionDialog, setIsVisibleRegionDialog] = useState(false);
    const handleRegionDialogCloseClick = useCallback(() => setIsVisibleRegionDialog(false), [setIsVisibleRegionDialog]);
    const handleRegionSelectClick = useCallback(() => setIsVisibleRegionDialog(true), [setIsVisibleRegionDialog]);
    const handleRegionDialogChange = useCallback((region) => {
        pushAnalyticEvent("regionDialogClick" /* EVENTS.REGION_DIALOG_CLICK */, { eventLabel: region.name });
    }, [pushAnalyticEvent]);
    const handleUserInfoMouseEnter = useCallback((event) => {
        setMenuVisible.on();
        onMouseEnter?.(event);
        pushAnalyticEvent("userMenuShow" /* EVENTS.USER_MENU_SHOW */, { eventLabel: `Профиль|Наведение` });
        pushAnalyticEvent("downloadApp" /* EVENTS.DOWNLOAD_APP */, {
            eventAction: 'Показ ссылки в Store',
            eventLabel: `Меню профиля|Общая кнопка и QR`,
        });
    }, [pushAnalyticEvent, onMouseEnter, setMenuVisible]);
    if (!user)
        return null;
    const userName = getUserName(user);
    const avatar = React__default.createElement(Avatar, { className: cx('avatar'), size: 36, src: `//f.sravni.ru/avatars/${user.sub}.svg` });
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Space, { align: "center", size: 12, className: cx('userInfo', className), ...restProps, onMouseEnter: handleUserInfoMouseEnter, onMouseLeave: setMenuVisible.off },
            hasNotification ? (React__default.createElement(Badge, { variant: "primary", color: "red" }, avatar)) : (avatar),
            React__default.createElement(Space, { direction: "vertical", align: "start" },
                userName ? (React__default.createElement(Text, { size: 12, className: "h-color-D30" }, "\u041F\u0440\u043E\u0444\u0438\u043B\u044C")) : null,
                React__default.createElement(Text, { strong: true, nowrap: true, className: cx('userName'), title: userName || 'Ваш профиль' }, userName || 'Ваш профиль')),
            menuVisible && (React__default.createElement("div", { className: cx('dropdownWrapper') },
                React__default.createElement("div", { className: cx('dropdown') },
                    React__default.createElement("div", { className: cx('dropdownArrow') }),
                    React__default.createElement(UserMenu, { onRegionSelectClick: handleRegionSelectClick, hasNotification: hasNotification }))))),
        React__default.createElement(RegionDialog, { serviceURL: serviceURL, formatPath: formatPath, regions: regions, visible: isVisibleRegionDialog, onClose: handleRegionDialogCloseClick, onChange: handleRegionDialogChange })));
};
DesktopUserBlock.displayName = 'DesktopUserBlock';

export { DesktopUserBlock };
//# sourceMappingURL=DesktopUserBlock.js.map
